/**
 * What covers the phone instead of the lesson, or nothing.
 *
 * The viewer has nothing to draw until the lesson is posted to it, so until then the
 * console says why rather than leaving a frame that could be read as someone else's
 * lesson. A refetch that fails keeps the lesson already on screen.
 */
export type PreviewCover = 'loading' | 'failed' | 'empty' | undefined;

export const COVER_COPY: Record<Exclude<PreviewCover, undefined>, string> = {
  loading: 'Loading preview…',
  failed: 'The preview could not load this lesson.',
  empty: 'No scenes yet — add one to see it here',
};

export function previewCover({
  sceneCount,
  failed,
  viewerReady,
}: {
  /** Undefined until the lesson has loaded. */
  sceneCount: number | undefined;
  failed: boolean;
  viewerReady: boolean;
}): PreviewCover {
  if (sceneCount === undefined) return failed ? 'failed' : 'loading';
  if (sceneCount === 0) return 'empty';
  return viewerReady ? undefined : 'loading';
}
